import { gql } from "apollo-boost";

export const gerenciarGruposLocaisListQuery = gql`
query gerenciarGruposLocaisListQuery ( $arquivado: Boolean ) {
    gruposLocaisList ( archived: $arquivado ) {
    id
    nome
    membros
  }
}`;

export const gerenciarGruposLocaisArquivarMutation = gql`
  mutation gerenciarGruposLocaisArquivar($id: Int) {
    grupoLocalArchive(id: $id) {
      id
    }
  }
`;

export const gerenciarGruposLocaisRestaurarMutation = gql`
  mutation gerenciarGruposLocaisRestaurar($id: Int) {
    grupoLocalRestore(id: $id) {
      id
    }
  }
`;

export const gerenciarGruposLocaisOne = gql`
  query gerenciarGruposLocaisOne($id: Int) {
    grupoLocalOne(id: $id) {
      id
      nome
    }
  }
`;

export const gerenciarGruposLocaisSave = gql`
  mutation gerenciarGruposLocaisSave($input: GrupoLocalInput!) {
    grupoLocalsave(input: $input) {
      id
    }
  }
`;